<template>
    <!-- 社会责任 -->
    <div class="responsibility">
        <div class="banner">
            <div class="banner-inner">
                <h2 class="title">社会责任</h2>
                <ul class="menu-list flex-align">
                    <li v-for="(item,index) in menuList" :key="index" class="menu-item csp"
                        :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
                        {{item.label}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="responsibility-inner">
            <div class="subtitle-warp">
                <el-carousel trigger="click" class="subtitle-carousel" :autoplay="false" :arrow="'never'"
                    @change="changeTitle" indicator-position="none">
                    <el-carousel-item v-for="item in 3" :key="item">
                        <h3 class="subtitle">{{menuList[activeMenu].label}}</h3>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <ul class="responsibility-list flex-layout">
                <li class="responsibility-item csp" v-for="(each,index) in responsibilityList" :key="index"
                    @click="goDetail(each)">
                    <div class="item-img-warp">
                        <img :src="each.cover" alt="" class="item-img">
                    </div>
                    <p class="item-subtitle">{{each.title}}</p>
                    <p class="item-desc wes-2">{{each.desc}}</p>
                </li>
            </ul>
        </div>
        <!-- <div class="responsibility-inner">
            <div class="subtitle-warp">
                <el-carousel trigger="click" class="subtitle-carousel" :autoplay="false" :arrow="'always'"
                    @change="changeTitle">
                    <el-carousel-item v-for="item in 3" :key="item">
                        <h3 class="subtitle">{{menuList[activeMenu].label}}·经典润乡土</h3>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <el-carousel trigger="click" height="700px" :autoplay="false" :arrow="'never'" :indicator-position="'none'"
                @setActiveItem="setActiveItem" ref="contentCarousel">
                <el-carousel-item v-for="(item,listIndex) in responsibilityList" :key="listIndex">
                    <ul class="responsibility-list flex-layout">
                        <li class="responsibility-item csp" v-for="(each,index) in item" :key="index" :arrow="'always'">
                            <img src="" alt="" class="item-img">
                            <p class="item-subtitle">{{each.title}}</p>
                            <p class="item-desc wes-2">{{each.desc}}</p>
                        </li>
                    </ul>
                </el-carousel-item>
            </el-carousel>
        </div> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeMenu: 0,
                menuList: [{
                        label: '教育扶贫',
                        dictValue: undefined,
                    },
                    {
                        label: '中西部协作',
                        dictValue: undefined,
                    },
                    {
                        label: '乡村振兴',
                        dictValue: undefined,
                    }
                ],
                responsibilityList: [
                    // [{
                    //     title: "经典润乡土",
                    //     desc: "首都师范大学“双优云桥·首师优字”项目入选教育部“经典润乡土计划”重点项目"
                    // }, {
                    //     title: "经典润乡土",
                    //     desc: "首都师范大学“双优云桥·首师优字”项目入选教育部“经典润乡土计划”重点项目"
                    // }, {
                    //     title: "经典润乡土",
                    //     desc: "首都师范大学“双优云桥·首师优字”项目入选教育部“经典润乡土计划”重点项目"
                    // }],
                    // [{
                    //     title: "经典润乡土",
                    //     desc: "主要从事教育基本原理、课程与教学论、教师教育、历史教学等方面的教学与研究。"
                    // }, {
                    //     title: "经典润乡土",
                    //     desc: "主要从事教育基本原理、课程与教学论、教师教育、历史教学等方面的教学与研究。"
                    // }, {
                    //     title: "新征程",
                    //     desc: "主要从事教育基本原理、课程与教学论、教师教育、历史教学等方面的教学与研究。"
                    // }],
                    // [{
                    //     title: "美育共同体",
                    //     desc: "中国”战略背景下，“双优云桥”教育服务中心以数字化助力区域、学校高质量发展，定位“双减”背景下学生的全面发展和教师的能力提升，为区域、学校建设新型基础设施。"
                    // }, {
                    //     title: "美育共同体",
                    //     desc: "中国”战略背景下，“双优云桥”教育服务中心以数字化助力区域、学校高质量发展，定位“双减”背景下学生的全面发展和教师的能力提升，为区域、学校建设新型基础设施"
                    // }, {
                    //     title: "美育共同体",
                    //     desc: "中国”战略背景下，“双优云桥”教育服务中心以数字化助力区域、学校高质量发展，定位“双减”背景下学生的全面发展和教师的能力提升，为区域、学校建设新型基础设施"
                    // }]
                ],
                currentTitleIndex: 0,
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
                this.getList(this.menuList[index].dictValue);
            },
            changeTitle(index) {
                this.currentTitleIndex = index;
                this.setActiveItem(index)
            },
            setActiveItem(index) {
                this.$refs.contentCarousel.setActiveItem(index);
            },
            async getLabes() {
                let resData = await Api.Home.getLabes({
                    dict: 'website_news_type'
                })
                // console.log('labes', resData)
                resData.data.map(item => {
                    this.menuList.map(each => {
                        if (item.label.indexOf(each.label) != -1) {
                            // console.log(item.label)
                            each.dictValue = item.dictValue;
                        }
                    })
                })
                // console.log('menuList', this.menuList)
                this.getList(this.menuList[this.activeMenu].dictValue);
            },
            async getList(type) {
                let params = {
                    clazz: type, //轮播图新闻
                    isAsc: 'desc',
                    pageNum: 1,
                    pageSize: 3,
                }
                let resData = await Api.Home.getNews(params)
                // console.log('news', resData)
                this.responsibilityList = resData.rows
            },
            goDetail(event) {
                // console.log('event', event);
                this.$router.push(`news/detail/${event.id}?breadNumber=3`)
            }

        },
        mounted() {
            this.getLabes();
        }
    }
</script>

<style lang="less" scoped>
    .responsibility {

        .banner {
            background-image: url("../assets/responsibility/banner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 56vh;
            max-height: 530px;
            min-height: 360px;
            padding-left: 6.9%;
            position: relative;

            .banner-inner {
                position: absolute;
                width: 100%;
                bottom: 8%;
            }


            .title {
                font-size: 48px;
                color: #fff;
                margin-bottom: 2.5%;
                letter-spacing: 2px;
            }

            .menu-list {
                padding-right: 65%;
            }

            .menu-item {
                color: #fff;
                font-size: 30px;
                // margin-bottom: 7.3%;
                letter-spacing: 2px;
                position: relative;
                width: 28%;
                font-weight: 300;

                &:nth-child(2) {
                    width: 33%;
                }

                &.active-menu {
                    font-weight: 400;
                }

                &.active-menu::before {
                    position: absolute;
                    content: " ";
                    width: 23px;
                    height: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -33px;
                    background-image: url("../assets/business/arrow.png");
                }
            }
        }

        .responsibility-inner {
            background-image: url("../assets/business/bg.png");
            background-position: bottom;
            background-repeat: no-repeat;
            padding: 3.5% 0 50%;

        }

        .subtitle-warp {
            padding: 0 4.5%;

            .subtitle-carousel {
                height: 125px;

                /deep/.el-carousel__container {
                    height: 100%;
                }
            }

            .subtitle {
                font-size: 36px;
                text-align: center;
            }

            /deep/ .el-carousel__arrow {
                background-color: #5F99FF;
                border-radius: 0%;
                top: 61%;

                i {
                    font-size: 15px;
                }

                &:hover {
                    opacity: .8;
                }
            }

            /deep/ .el-carousel__indicators {
                bottom: 40%;

                .el-carousel__button {
                    background-color: #DCDCDC;
                    height: 6px;
                    width: 51px;
                }

                .is-active .el-carousel__button {
                    background-color: #2C79FF;
                }
            }
        }



        .responsibility-list {
            background-color: #f5f5f5;
            padding: 3.5% 5.2%;

            .responsibility-item {
                margin-right: 4.4%;
                width: calc((100% - 4.4% * 2) / 3);

                &:hover .item-desc {
                    color: #014EA5;
                }

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }

            .item-img-warp {
                width: 100%;
                height: 400px;
                position: relative;
                z-index: 1;

                &::before {
                    content: " ";
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 90%;
                    height: 86%;
                    border: 1px solid #fff;
                    z-index: 2;
                }
            }

            .item-img {
                width: 100%;
                height: 400px;
            }

            .item-subtitle {
                font-size: 16px;
                color: #7e7e7e;
                margin: 8.3% 0 5%;

                &::before {
                    display: inline-block;
                    content: " ";
                    width: 10px;
                    height: 10px;
                    background-color: #a40000;
                    border-radius: 50%;
                    margin-right: 13px;
                }
            }

            .item-desc {
                font-size: 22px;
                line-height: 1.63;

            }
        }



        @media screen and (max-width:1850px) {
            .banner {
                .title {
                    font-size: 40px;
                }


                .menu-item {
                    font-size: 25px;
                }
            }

            .subtitle-warp {
                .subtitle-carousel {
                    height: 105px;
                }

                .subtitle {
                    font-size: 30px;
                }
            }

            .responsibility-list {
                .item-img {
                    height: 330px;
                }

                .item-subtitle {
                    font-size: 14px;
                }

                .item-desc {
                    font-size: 18px;
                }
            }

        }

        @media screen and (max-width:1450px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 31px;
                }

                .menu-item {
                    font-size: 20px;
                }
            }

            .subtitle-warp {
                .subtitle-carousel {
                    height: 95px;
                }

                .subtitle {
                    font-size: 26px;
                }
            }

            .responsibility-list {
                .item-img {
                    height: 260px;
                }

                .item-subtitle {
                    font-size: 14px;
                }

                .item-desc {
                    font-size: 16px;
                }
            }
        }

        @media screen and (max-width:1150px) {
            .banner {
                .title {
                    font-size: 25px;
                }


                .menu-item {
                    font-size: 16px;
                }
            }

            .responsibility-list {
                .item-img {
                    height: 210px;
                }

                .item-subtitle {
                    font-size: 12px;
                }

                .item-desc {
                    font-size: 12px;
                }
            }
        }
    }
</style>